import { bluePalette } from '../../themes/colors';
import { bluePaletteDark, grayPaletteDark, royalBluePaletteDark } from '../../themes/dark-colors';

export const buttonGroupDarkTheme = {
  backgroundColor: grayPaletteDark[0],
  color: grayPaletteDark[600],
  borderColor: bluePalette[700],
  edgeButtonRadius: '3px',
  selected: {
    color: grayPaletteDark[1000],
    backgroundColor: bluePalette[700],
    borderColor: bluePalette[700],
    borderTopColor: bluePalette[700],
    borderBottomColor: bluePalette[700],
  },
  disabled: {
    backgroundColor: grayPaletteDark[300],
    color: grayPaletteDark[500],
    borderColor: bluePalette[700],
  },
  hover: {
    color: royalBluePaletteDark[1000],
    backgroundColor: bluePaletteDark[200],
  },
};
